import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { Note, UUID } from "@/core/types";

import { getNotesSummary } from "../queryFunctions/getNotesSummary";
import { noteKeys } from "../keyFactory";

type UseNotesSummaryProps<TData = Note[]> = {
  patientId: UUID;
  select?: (data: Note[]) => TData;
};

type NotesSummaryQueryOptions = UseQueryOptions<
  Note[],
  unknown,
  Note[],
  ReturnType<typeof noteKeys.summary>
>;

export function useNotesSummary<TData = Note[]>({
  patientId,
  select,
}: UseNotesSummaryProps<TData>) {
  return useQuery({ ...optionFactory(patientId), select });
}

export function optionFactory(patientId: UUID) {
  return {
    queryFn: () => getNotesSummary(patientId),
    queryKey: noteKeys.summary(patientId),
    refetchOnWindowFocus: "always",
    staleTime: 0,
  } satisfies NotesSummaryQueryOptions;
}
